export default __webpack_public_path__ + "static/media/hbs-k-blk-poster-2.8a5eefdf.jpg";